import React, { useState } from "react";
import "./Carousel.css";
import { carouselData } from "./Data";

export default function Carousel() {
  const [active, setActive] = useState(0);

  const nextSlide = () => {
    setActive((prev) => (prev + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setActive((prev) =>
      prev === 0 ? carouselData.length - 1 : prev - 1
    );
  };

  return (
    <div className="carousel-container">
      {/* FIXED HEADING */}
      <h1 className="carousel-heading">
        Everything’s new. Except the attitude.
      </h1>

      <div className="carousel-inner">
        {/* LEFT SIDE CONTENT */}
        <div className="carousel-left">
          <div className="pagination-row">
            <span className="arrow2" onClick={prevSlide}>‹</span>

            {carouselData.map((item, index) => (
              <span
                key={item.id}
                className={`page-number ${
                  index === active ? "active" : ""
                }`}
                onClick={() => setActive(index)}
              >
                {item.id}
              </span>
            ))}

            <span className="arrow2" onClick={nextSlide}>›</span>
          </div>

          <h2 className="carousel-title">
            {carouselData[active].title}
          </h2>

          <p className="carousel-description">
            {carouselData[active].description}
          </p>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <div className="carousel-right">
          <img
            src={carouselData[active].image}
            alt="slide"
            className="carousel-img"
            loading="eager"
            decoding="async"
            fetchpriority={active === 0 ? "high" : "auto"}
          />
        </div>
      </div>
    </div>
  );
}
